<div class="button-container" [class.expanded]="isExpanded" #button>
  <button (click)="toggleExpand()" class="expand-button position-relative">
    <div class="icon-container">
      <mat-icon class="icon">
        {{ !isExpanded ? 'help' : 'cancel' }}
      </mat-icon>
    </div>
    <div *ngIf="isExpanded" class="expanded-text orgbrain-text orgbrain-default-font small-shadow">
      <ng-content></ng-content>
    </div>
  </button>
</div>
